import { Grid } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { MyCard } from './my-card';

const dummyData = [
 {
  id: 1,
  thumbUrl: 'http://dummyimage.com/423x791.png/5fa2dd/ffffff',
 },
 {
  id: 2,
  thumbUrl: 'http://dummyimage.com/359x689.png/dddddd/000000',
 },
 {
  id: 3,
  thumbUrl: 'http://dummyimage.com/415x760.png/5fa2dd/ffffff',
 },
 {
  id: 4,
  thumbUrl: 'http://dummyimage.com/310x648.png/cc0000/ffffff',
 },
 {
  id: 5,
  thumbUrl: 'http://dummyimage.com/312x635.png/cc0000/ffffff',
 },
 {
  id: 6,
  thumbUrl: 'http://dummyimage.com/326x616.png/5fa2dd/ffffff',
 },
 {
  id: 7,
  thumbUrl: 'http://dummyimage.com/415x754.png/cc0000/ffffff',
 },
 {
  id: 8,
  thumbUrl: 'http://dummyimage.com/332x773.png/cc0000/ffffff',
 },
 {
  id: 9,
  thumbUrl: 'http://dummyimage.com/422x564.png/ff4444/ffffff',
 },
 {
  id: 10,
  thumbUrl: 'http://dummyimage.com/346x656.png/dddddd/000000',
 },
 {
  id: 11,
  thumbUrl: 'http://dummyimage.com/449x693.png/dddddd/000000',
 },
 {
  id: 12,
  thumbUrl: 'http://dummyimage.com/361x630.png/cc0000/ffffff',
 },
 {
  id: 13,
  thumbUrl: 'http://dummyimage.com/475x722.png/cc0000/ffffff',
 },
 {
  id: 14,
  thumbUrl: 'http://dummyimage.com/368x625.png/ff4444/ffffff',
 },
 {
  id: 15,
  thumbUrl: 'http://dummyimage.com/318x652.png/5fa2dd/ffffff',
 },
 {
  id: 16,
  thumbUrl: 'http://dummyimage.com/346x542.png/5fa2dd/ffffff',
 },
 {
  id: 17,
  thumbUrl: 'http://dummyimage.com/332x717.png/ff4444/ffffff',
 },
 {
  id: 18,
  thumbUrl: 'http://dummyimage.com/318x509.png/5fa2dd/ffffff',
 },
 {
  id: 19,
  thumbUrl: 'http://dummyimage.com/492x698.png/cc0000/ffffff',
 },
 {
  id: 20,
  thumbUrl: 'http://dummyimage.com/499x683.png/ff4444/ffffff',
 },
 {
  id: 21,
  thumbUrl: 'http://dummyimage.com/448x742.png/dddddd/000000',
 },
 {
  id: 22,
  thumbUrl: 'http://dummyimage.com/372x525.png/dddddd/000000',
 },
 {
  id: 23,
  thumbUrl: 'http://dummyimage.com/323x571.png/ff4444/ffffff',
 },
 {
  id: 24,
  thumbUrl: 'http://dummyimage.com/310x769.png/5fa2dd/ffffff',
 },
 {
  id: 25,
  thumbUrl: 'http://dummyimage.com/447x692.png/5fa2dd/ffffff',
 },
 {
  id: 26,
  thumbUrl: 'http://dummyimage.com/443x505.png/cc0000/ffffff',
 },
 {
  id: 27,
  thumbUrl: 'http://dummyimage.com/369x599.png/cc0000/ffffff',
 },
 {
  id: 28,
  thumbUrl: 'http://dummyimage.com/461x744.png/5fa2dd/ffffff',
 },
 {
  id: 29,
  thumbUrl: 'http://dummyimage.com/344x790.png/5fa2dd/ffffff',
 },
 {
  id: 30,
  thumbUrl: 'http://dummyimage.com/464x626.png/cc0000/ffffff',
 },
 {
  id: 31,
  thumbUrl: 'http://dummyimage.com/499x746.png/dddddd/000000',
 },
 {
  id: 32,
  thumbUrl: 'http://dummyimage.com/329x649.png/cc0000/ffffff',
 },
 {
  id: 33,
  thumbUrl: 'http://dummyimage.com/321x527.png/dddddd/000000',
 },
 {
  id: 34,
  thumbUrl: 'http://dummyimage.com/464x560.png/cc0000/ffffff',
 },
 {
  id: 35,
  thumbUrl: 'http://dummyimage.com/419x770.png/5fa2dd/ffffff',
 },
 {
  id: 36,
  thumbUrl: 'http://dummyimage.com/483x674.png/ff4444/ffffff',
 },
 {
  id: 37,
  thumbUrl: 'http://dummyimage.com/391x625.png/cc0000/ffffff',
 },
 {
  id: 38,
  thumbUrl: 'http://dummyimage.com/386x558.png/5fa2dd/ffffff',
 },
 {
  id: 39,
  thumbUrl: 'http://dummyimage.com/391x612.png/dddddd/000000',
 },
 {
  id: 40,
  thumbUrl: 'http://dummyimage.com/432x789.png/cc0000/ffffff',
 },
 {
  id: 41,
  thumbUrl: 'http://dummyimage.com/469x556.png/ff4444/ffffff',
 },
 {
  id: 42,
  thumbUrl: 'http://dummyimage.com/369x744.png/cc0000/ffffff',
 },
 {
  id: 43,
  thumbUrl: 'http://dummyimage.com/460x714.png/5fa2dd/ffffff',
 },
 {
  id: 44,
  thumbUrl: 'http://dummyimage.com/428x674.png/cc0000/ffffff',
 },
 {
  id: 45,
  thumbUrl: 'http://dummyimage.com/373x561.png/ff4444/ffffff',
 },
 {
  id: 46,
  thumbUrl: 'http://dummyimage.com/425x708.png/dddddd/000000',
 },
 {
  id: 47,
  thumbUrl: 'http://dummyimage.com/448x675.png/dddddd/000000',
 },
 {
  id: 48,
  thumbUrl: 'http://dummyimage.com/369x691.png/5fa2dd/ffffff',
 },
 {
  id: 49,
  thumbUrl: 'http://dummyimage.com/466x580.png/ff4444/ffffff',
 },
 {
  id: 50,
  thumbUrl: 'http://dummyimage.com/413x522.png/cc0000/ffffff',
 },
 {
  id: 51,
  thumbUrl: 'http://dummyimage.com/453x510.png/dddddd/000000',
 },
 {
  id: 52,
  thumbUrl: 'http://dummyimage.com/466x799.png/dddddd/000000',
 },
 {
  id: 53,
  thumbUrl: 'http://dummyimage.com/311x764.png/cc0000/ffffff',
 },
 {
  id: 54,
  thumbUrl: 'http://dummyimage.com/359x606.png/cc0000/ffffff',
 },
 {
  id: 55,
  thumbUrl: 'http://dummyimage.com/469x753.png/cc0000/ffffff',
 },
 {
  id: 56,
  thumbUrl: 'http://dummyimage.com/324x541.png/cc0000/ffffff',
 },
 {
  id: 57,
  thumbUrl: 'http://dummyimage.com/450x739.png/cc0000/ffffff',
 },
 {
  id: 58,
  thumbUrl: 'http://dummyimage.com/491x698.png/cc0000/ffffff',
 },
 {
  id: 59,
  thumbUrl: 'http://dummyimage.com/349x733.png/5fa2dd/ffffff',
 },
 {
  id: 60,
  thumbUrl: 'http://dummyimage.com/441x723.png/5fa2dd/ffffff',
 },
 {
  id: 61,
  thumbUrl: 'http://dummyimage.com/350x724.png/cc0000/ffffff',
 },
 {
  id: 62,
  thumbUrl: 'http://dummyimage.com/435x568.png/5fa2dd/ffffff',
 },
 {
  id: 63,
  thumbUrl: 'http://dummyimage.com/343x502.png/dddddd/000000',
 },
 {
  id: 64,
  thumbUrl: 'http://dummyimage.com/482x600.png/cc0000/ffffff',
 },
 {
  id: 65,
  thumbUrl: 'http://dummyimage.com/446x661.png/ff4444/ffffff',
 },
 {
  id: 66,
  thumbUrl: 'http://dummyimage.com/393x501.png/cc0000/ffffff',
 },
 {
  id: 67,
  thumbUrl: 'http://dummyimage.com/435x800.png/dddddd/000000',
 },
 {
  id: 68,
  thumbUrl: 'http://dummyimage.com/375x595.png/dddddd/000000',
 },
 {
  id: 69,
  thumbUrl: 'http://dummyimage.com/364x511.png/ff4444/ffffff',
 },
 {
  id: 70,
  thumbUrl: 'http://dummyimage.com/497x774.png/5fa2dd/ffffff',
 },
 {
  id: 71,
  thumbUrl: 'http://dummyimage.com/306x710.png/ff4444/ffffff',
 },
 {
  id: 72,
  thumbUrl: 'http://dummyimage.com/380x746.png/5fa2dd/ffffff',
 },
 {
  id: 73,
  thumbUrl: 'http://dummyimage.com/330x592.png/ff4444/ffffff',
 },
 {
  id: 74,
  thumbUrl: 'http://dummyimage.com/443x623.png/5fa2dd/ffffff',
 },
 {
  id: 75,
  thumbUrl: 'http://dummyimage.com/439x638.png/cc0000/ffffff',
 },
 {
  id: 76,
  thumbUrl: 'http://dummyimage.com/484x797.png/ff4444/ffffff',
 },
 {
  id: 77,
  thumbUrl: 'http://dummyimage.com/318x648.png/dddddd/000000',
 },
 {
  id: 78,
  thumbUrl: 'http://dummyimage.com/442x686.png/ff4444/ffffff',
 },
 {
  id: 79,
  thumbUrl: 'http://dummyimage.com/494x592.png/ff4444/ffffff',
 },
 {
  id: 80,
  thumbUrl: 'http://dummyimage.com/386x705.png/5fa2dd/ffffff',
 },
 {
  id: 81,
  thumbUrl: 'http://dummyimage.com/359x794.png/5fa2dd/ffffff',
 },
 {
  id: 82,
  thumbUrl: 'http://dummyimage.com/331x749.png/5fa2dd/ffffff',
 },
 {
  id: 83,
  thumbUrl: 'http://dummyimage.com/393x697.png/ff4444/ffffff',
 },
 {
  id: 84,
  thumbUrl: 'http://dummyimage.com/445x616.png/5fa2dd/ffffff',
 },
 {
  id: 85,
  thumbUrl: 'http://dummyimage.com/380x743.png/dddddd/000000',
 },
 {
  id: 86,
  thumbUrl: 'http://dummyimage.com/457x531.png/5fa2dd/ffffff',
 },
 {
  id: 87,
  thumbUrl: 'http://dummyimage.com/378x579.png/ff4444/ffffff',
 },
 {
  id: 88,
  thumbUrl: 'http://dummyimage.com/357x550.png/ff4444/ffffff',
 },
 {
  id: 89,
  thumbUrl: 'http://dummyimage.com/489x612.png/dddddd/000000',
 },
 {
  id: 90,
  thumbUrl: 'http://dummyimage.com/492x631.png/ff4444/ffffff',
 },
 {
  id: 91,
  thumbUrl: 'http://dummyimage.com/469x708.png/ff4444/ffffff',
 },
 {
  id: 92,
  thumbUrl: 'http://dummyimage.com/317x666.png/5fa2dd/ffffff',
 },
 {
  id: 93,
  thumbUrl: 'http://dummyimage.com/361x652.png/5fa2dd/ffffff',
 },
 {
  id: 94,
  thumbUrl: 'http://dummyimage.com/344x681.png/dddddd/000000',
 },
 {
  id: 95,
  thumbUrl: 'http://dummyimage.com/471x506.png/cc0000/ffffff',
 },
 {
  id: 96,
  thumbUrl: 'http://dummyimage.com/457x759.png/ff4444/ffffff',
 },
 {
  id: 97,
  thumbUrl: 'http://dummyimage.com/371x791.png/ff4444/ffffff',
 },
 {
  id: 98,
  thumbUrl: 'http://dummyimage.com/464x778.png/5fa2dd/ffffff',
 },
 {
  id: 99,
  thumbUrl: 'http://dummyimage.com/343x721.png/5fa2dd/ffffff',
 },
 {
  id: 100,
  thumbUrl: 'http://dummyimage.com/416x606.png/5fa2dd/ffffff',
 },
];

export default function MyCards() {
 const [myCards, setMyCards] = useState(dummyData);

 return (
  <Grid container spacing={2}>
   {myCards.map((card) => (
    <Grid item xs={3}>
     <MyCard card={card} />
    </Grid>
   ))}
  </Grid>
 );
}
